"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkNewConstrictionWithCommercial = exports.checkParamsForNewPtypes = exports.seoUrlHasTraspasosPtypesToRedirect = exports.hasTraspasosPtypesToRedirect = exports.SEO_PTYPES_CONVERSIONS_TRASPASOS = exports.PTYPES_CONVERSIONS_TRASPASOS = exports.callApi = exports.PUBLISHERS_URLS_TO_REDIRECT = exports.S3CONFIGFILES = exports.LH_BASE_URL = exports.LHLOCATIONS = exports.ESAPI = exports.HTTP_VERB_POST = exports.HTTP_VERB_GET = void 0;

var _superagent = _interopRequireDefault(require("superagent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HTTP_VERB_GET = 'GET';
exports.HTTP_VERB_GET = HTTP_VERB_GET;
var HTTP_VERB_POST = 'POST';
exports.HTTP_VERB_POST = HTTP_VERB_POST;
var ESAPI = 'https://api-search.prd.casa.it/listings/v2/search/';
exports.ESAPI = ESAPI;
var LHLOCATIONS = 'https://api-lh.casa.it/lh/v2/locations/?ids={zones}&site={site}';
exports.LHLOCATIONS = LHLOCATIONS;
var LH_BASE_URL = 'https://api-lh.casa.it/';
exports.LH_BASE_URL = LH_BASE_URL;
var S3CONFIGFILES = 'https://app.casa.it';
exports.S3CONFIGFILES = S3CONFIGFILES;
var PUBLISHERS_URLS_TO_REDIRECT = ['vendita-residenziale' // 'vendita-commerciale',
// 'vendita-vacanza',
// 'vendita-vacanze',
// 'affitti-residenziale',
// 'affitti-commerciale',
// 'affitti-vacanza',
// 'affitti-vacanze',
// 'affitto-residenziale',
// 'affitto-commerciale',
// 'affitto-vacanza',
// 'affitto-vacanze',
];
exports.PUBLISHERS_URLS_TO_REDIRECT = PUBLISHERS_URLS_TO_REDIRECT;

var callApi = function callApi(url, verb) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return new Promise(function (resolve) {
    switch (verb) {
      case HTTP_VERB_POST:
        _superagent["default"].post(url).set('Content-Type', 'application/json').set('Accept-Encoding', 'gzip, deflate').send(body).end(function (errReq, resReq) {
          try {
            if (errReq) {
              console.error("Error handling response from url ".concat(url));
              console.error("Esapi response: ".concat(errReq));
              return resolve([]);
            }

            return resolve(resReq.body.data);
          } catch (err) {
            console.error("Error handling response from url ".concat(url, " - err: ").concat(err));
            console.error("Esapi response: ".concat(resReq.body));
            console.error("Stack: ".concat(err.stack));
            return resolve([]);
          }
        });

        break;

      default:
        _superagent["default"].get(url).set('Content-Type', 'application/json').set('Accept-Encoding', 'gzip, deflate').end(function (errReq, resReq) {
          try {
            if (errReq) {
              console.error("Error handling response from url ".concat(url));
              console.error("ApiLH response: ".concat(errReq));
              return resolve([]);
            }

            return resolve(resReq.body.data);
          } catch (err) {
            console.error("Error handling response from url ".concat(url, " - err: ").concat(err));
            console.error("ApiLH response: ".concat(resReq.body));
            console.error("Stack: ".concat(err.stack));
            return resolve([]);
          }
        });

        break;
    }
  });
};

exports.callApi = callApi;
var PTYPES_TO_REDIRECT_TO_PGROUP = {
  'posto+letto': 'stanze',
  'cantina+solaio': 'residenziale',
  'garage+auto+silos': 'garage-posti-auto'
};
var PTYPES_TERRENI_TO_REDIRECT = ['terreno+industriale', 'terreno+agricolo', 'terreno+edificabile'];
var PTYPES_RESIDENZIALE_TO_REDIRECT = ['baita+chalet+trullo', 'bungalow', 'immobile+di+prestigio', 'palazzo', 'porzione+di+casa'];
var PTYPES_COMMERCIALE_TO_REDIRECT = ['show+room', 'stabile+palazzo', 'azienda+agricola'];
var PTYPES_VACANZE_TO_REDIRECT = ['attico+mansarda', 'bungalow', 'baita+chalet+trullo', 'loft', 'rustico+casale'];
var PTYPES_VACANZE_TO_MANTAIN = ['appartamento', 'villa', 'villetta+a+schiera', 'casa+indipendente'];
var PTYPES_CONVERSIONS_TRASPASOS = {
  'albergo': {
    propertyTypes: 'attivita+licenza+commerciale',
    license_type_groups: 'struttura-ricettiva'
  },
  'bar': {
    propertyTypes: 'attivita+licenza+commerciale',
    license_type_groups: 'bar-pub-caffe'
  },
  'laboratorio': {
    propertyTypes: 'negozio+locale+commerciale',
    license_type_groups: 'laboratori'
  },
  'ristorante': {
    propertyTypes: 'attivita+licenza+commerciale',
    license_type_groups: 'ristorazione'
  },
  'magazzino': {
    propertyTypes: 'negozio+locale+commerciale' // license_type_groups: 'magazzino',

  },
  'show+room': {
    propertyTypes: 'negozio+locale+commerciale',
    license_type_groups: 'altre-attivita'
  },
  'azienda+agricola': {
    propertyTypes: 'attivita+licenza+commerciale',
    license_type_groups: 'altre-attivita'
  },
  'stabile+palazzo': {
    propertyTypeGroup: 'edifici-palazzi'
  },
  'palazzo': {
    propertyTypeGroup: 'edifici-palazzi'
  },
  'negozio': {
    propertyTypes: 'negozio+locale+commerciale'
  }
};
exports.PTYPES_CONVERSIONS_TRASPASOS = PTYPES_CONVERSIONS_TRASPASOS;
var SEO_PTYPES_CONVERSIONS_TRASPASOS = {
  'albergo': {
    propertyTypeGroup: 'commerciale',
    category: 'commerciale',
    propertyTypes: ['attivita+licenza+commerciale'],
    license_type_groups: 'struttura-ricettiva'
  },
  'bar': {
    propertyTypeGroup: 'commerciale',
    category: 'commerciale',
    propertyTypes: ['attivita+licenza+commerciale'],
    license_type_groups: 'bar-pub-caffe'
  },
  'laboratorio': {
    propertyTypeGroup: 'commerciale',
    category: 'commerciale',
    propertyTypes: ['negozio+locale+commerciale'],
    license_type_groups: ['laboratorio']
  },
  'ristorante': {
    propertyTypeGroup: 'commerciale',
    category: 'commerciale',
    propertyTypes: ['attivita+licenza+commerciale'],
    license_type_groups: 'ristorazione'
  },
  'magazzino': {
    propertyTypeGroup: 'commerciale',
    category: 'commerciale',
    propertyTypes: ['negozio+locale+commerciale']
  },
  'show+room': {
    propertyTypeGroup: 'commerciale',
    category: 'commerciale',
    propertyTypes: ['negozio+locale+commerciale'],
    license_type_groups: 'altre-attivita'
  },
  'azienda+agricola': {
    propertyTypeGroup: 'commerciale',
    category: 'commerciale',
    propertyTypes: ['attivita+licenza+commerciale'],
    license_type_groups: 'altre-attivita'
  },
  'stabile+palazzo': {
    propertyTypeGroup: 'edifici-palazzi',
    category: 'edifici-palazzi'
  },
  'palazzo': {
    propertyTypeGroup: 'edifici-palazzi',
    category: 'edifici-palazzi'
  },
  'negozio': {
    propertyTypeGroup: 'commerciale',
    category: 'commerciale',
    propertyTypes: 'negozio+locale+commerciale'
  }
};
exports.SEO_PTYPES_CONVERSIONS_TRASPASOS = SEO_PTYPES_CONVERSIONS_TRASPASOS;

var hasTraspasosPtypesToRedirect = function hasTraspasosPtypesToRedirect(qo) {
  if ((qo.propertyTypeGroup === 'commerciale' || qo.propertyTypeGroup === 'case') && qo.propertyTypes) {
    var types = !Array.isArray(qo.propertyTypes) ? qo.propertyTypes.split(',') : qo.propertyTypes;
    var check = types.filter(function (t) {
      return Object.keys(PTYPES_CONVERSIONS_TRASPASOS).includes(t);
    });
    return check;
  }

  return false;
};

exports.hasTraspasosPtypesToRedirect = hasTraspasosPtypesToRedirect;

var seoUrlHasTraspasosPtypesToRedirect = function seoUrlHasTraspasosPtypesToRedirect(params) {
  var _ref = params.license_type_groups || [],
      _ref2 = _slicedToArray(_ref, 1),
      ltg = _ref2[0];

  var _ref3 = params.propertyTypes || [],
      _ref4 = _slicedToArray(_ref3, 1),
      pt = _ref4[0];

  if (ltg && Object.keys(SEO_PTYPES_CONVERSIONS_TRASPASOS).includes(ltg) && !pt) {
    delete params.propertyTypeGroup;
    delete params.category;
    delete params.category;
    delete params.propertyTypes;
    delete params.license_type_groups;
    return _objectSpread({}, params, {}, SEO_PTYPES_CONVERSIONS_TRASPASOS[ltg]);
  }

  return params;
};

exports.seoUrlHasTraspasosPtypesToRedirect = seoUrlHasTraspasosPtypesToRedirect;

var checkParamsForNewPtypes = function checkParamsForNewPtypes(params, seoManager) {
  if (params.propertyTypes && Array.isArray(params.propertyTypes)) {
    var ltg = [];
    params.propertyTypes.map(function (ptype, i) {
      if (Object.keys(PTYPES_TO_REDIRECT_TO_PGROUP).includes(ptype)) {
        params.category = PTYPES_TO_REDIRECT_TO_PGROUP[ptype];
        delete params.numRooms;
        delete params.numRoomsMin;
        delete params.numRoomsMax;
        delete params.propertyTypes;
      } else if (PTYPES_TERRENI_TO_REDIRECT.includes(ptype) && params.category !== 'terreni' && params.tr === 'affitti') {
        params.category = 'terreni';
        delete params.propertyTypes;
      } else if (Object.keys(PTYPES_CONVERSIONS_TRASPASOS).includes(ptype)) {
        var _PTYPES_CONVERSIONS_T = PTYPES_CONVERSIONS_TRASPASOS[ptype],
            propertyTypeGroup = _PTYPES_CONVERSIONS_T.propertyTypeGroup,
            propertyTypes = _PTYPES_CONVERSIONS_T.propertyTypes,
            license_type_groups = _PTYPES_CONVERSIONS_T.license_type_groups;

        if (propertyTypeGroup) {
          params.category = propertyTypeGroup;
          delete params.propertyTypes;
        } else {
          params.propertyTypes.splice(i, 1);
          params.propertyTypes.push(propertyTypes);

          if (license_type_groups) {
            ltg.push(license_type_groups);
          }
        }
      }

      if (ltg.length) {
        params.license_type_groups = ltg;
      }
    });
  }

  switch (params.category) {
    case 'residenziale':
      if (params.propertyTypes && Array.isArray(params.propertyTypes)) {
        params.propertyTypes = params.propertyTypes.filter(function (ptype) {
          return !PTYPES_RESIDENZIALE_TO_REDIRECT.includes(ptype);
        });

        if (params.propertyTypes.length === 0) {
          delete params.propertyTypes;
          params.category = 'residenziale';
          delete params.numRooms;
          delete params.numRoomsMin;
          delete params.numRoomsMax;
        } else {
          var isPtypeToDelete = false;
          params.propertyTypes.map(function (ptype) {
            if (ptype === 'cantina+solaio' || ptype === 'garage+box+auto') {
              params.category = 'garage-posti-auto';
              isPtypeToDelete = true;
              delete params.numRooms;
              delete params.numRoomsMin;
              delete params.numRoomsMax;
            }
          });

          if (isPtypeToDelete) {
            delete params.propertyTypes;
          }
        }
      }

      if (params.numRoomsMin && params.numRoomsMin === params.numRoomsMax) {
        delete params.propertyTypes;
      }

      if (params.numRooms && !params.numRoomsMax && !params.numRoomsMin) {
        params.numRoomsMin = params.numRooms;
        params.numRoomsMax = params.numRooms;
      }

      break;

    case 'commerciale':
    /* TECH-7860 - TRASPASOS */

    case 'capannoni':
    case 'uffici':
    case 'edifici-palazzi':
      /* TECH-7860 - TRASPASOS */
      if (params.propertyTypes && Array.isArray(params.propertyTypes)) {
        if (params.numRooms || params.numRoomsMin || params.numRoomsMax) {
          delete params.numRooms;
          delete params.numRoomsMin;
          delete params.numRoomsMax;
        }

        params.propertyTypes = params.propertyTypes.filter(function (ptype) {
          return !PTYPES_COMMERCIALE_TO_REDIRECT.includes(ptype);
        });

        if (params.propertyTypes.length === 0) {
          delete params.propertyTypes;
        } else {
          params.propertyTypes.map(function (ptype, index) {
            if (ptype === 'cessione+di+azienda') {
              params.propertyTypes.splice(index, 1);
              params.propertyTypes.push('attivita+licenza+commerciale');
            }
          });
        }
      } else if (params.numRooms || params.numRoomsMin || params.numRoomsMax) {
        delete params.numRooms;
        delete params.numRoomsMin;
        delete params.numRoomsMax;
      }

      if (params.heatingType && params.category !== 'commerciale' && params.category !== 'capannoni') {
        delete params.heatingType;
      }

      break;

    case 'vacanze':
      switch (params.tr) {
        case 'vendita':
          delete params.numRooms;
          delete params.numRoomsMin;
          delete params.numRoomsMax;
          params.category = 'residenziale';

          if (params.propertyTypes && Array.isArray(params.propertyTypes)) {
            params.propertyTypes.map(function (ptype) {
              if (PTYPES_TERRENI_TO_REDIRECT.includes(params.propertyTypes[0]) || params.propertyTypes[0] === 'terreno') {
                params.category = 'terreni';
                delete params.propertyTypes;
              } else if (PTYPES_RESIDENZIALE_TO_REDIRECT.includes(ptype)) {
                params.category = 'residenziale';
                delete params.propertyTypes;
              }
            });
          }

          break;

        case 'affitti':
          params.propertyTypes = Array.isArray(params.propertyTypes) ? params.propertyTypes.filter(function (ptype) {
            return !PTYPES_VACANZE_TO_REDIRECT.includes(ptype);
          }) : [];

          if (params.propertyTypes.length === 0) {
            delete params.numRooms;
            delete params.numRoomsMin;
            delete params.numRoomsMax;
            delete params.propertyTypes;
          }

          if (params.propertyTypes && params.propertyTypes.length === 1) {
            delete params.numRooms;
            delete params.numRoomsMin;
            delete params.numRoomsMax;

            if (!PTYPES_VACANZE_TO_MANTAIN.includes(params.propertyTypes[0])) {
              if (PTYPES_TERRENI_TO_REDIRECT.includes(params.propertyTypes[0]) || params.propertyTypes[0] === 'terreno') {
                params.category = 'terreni';

                if (params.propertyTypes[0] === 'terreno') {
                  delete params.propertyTypes;
                }
              } else {
                params.category = 'residenziale';
                delete params.propertyTypes;
              }
            }
          }

          break;
      }

      break;

    case 'stanze':
      delete params.numRooms;
      delete params.numRoomsMin;
      delete params.numRoomsMax;
      delete params.terrace;
      delete params.balcony;

      switch (params.tr) {
        case 'vendita':
          params.category = 'residenziale';
          delete params.propertyTypes;
          break;
      }

      break;

    case 'terreni':
      delete params.numRooms;
      delete params.numRoomsMin;
      delete params.numRoomsMax;
      params.category = 'terreni';
      /**
       * TECH 7028
       * industriali --> edificabili
       */

      var ptypes = params.propertyTypes && Array.isArray(params.propertyTypes);

      if (ptypes && params.propertyTypes.includes('terreno+industriale')) {
        params.propertyTypes = ['terreno+edificabile'];
      }

      break;

    case 'cantine-solai':
      delete params.numRooms;
      delete params.numRoomsMin;
      delete params.numRoomsMax;
      params.category = 'residenziale';
      break;
  }
  /* OLD DECODE WITH WRONGPROPERTYTYPES */


  if (params.wrongPropertyTypes && Array.isArray(params.wrongPropertyTypes)) {
    params.propertyTypes = [];
    params.wrongPropertyTypes.map(function (wptype) {
      if (PTYPES_TERRENI_TO_REDIRECT.includes(wptype)) {
        if (params.propertyTypes) {
          params.propertyTypes.push(wptype);
          params.category = 'terreni';
        }

        delete params.wrongPropertyTypes;
      } else if (wptype === 'nuova+costruzione') {
        params.buildingCondition = 'nuovo';
        delete params.wrongPropertyTypes;
        delete params.propertyTypes;
      } else if (wptype === 'attivita+licenza+comm') {
        params.category = 'commerciale';
        delete params.wrongPropertyTypes;
        delete params.propertyTypes;
      } else if (Object.keys(PTYPES_TO_REDIRECT_TO_PGROUP).includes(wptype)) {
        params.category = 'residenziale';
        delete params.wrongPropertyTypes;
        delete params.propertyTypes;
      } else {
        delete params.wrongPropertyTypes;
        delete params.propertyTypes;
      }
    });
  }
};

exports.checkParamsForNewPtypes = checkParamsForNewPtypes;

var checkNewConstrictionWithCommercial = function checkNewConstrictionWithCommercial(params) {
  var is404 = false;
  var redProperties = {};
  /* TECH-7860 - TRASPASOS */

  var allCommercialGroups = ['commerciale', 'capannoni', 'uffici', 'edifici-palazzi'];

  if (params.buildingCondition === 'nuovo' && allCommercialGroups.indexOf(params.propertyTypeGroup) > -1) {
    is404 = true;
    redProperties.statusCode = 404;
  }

  ;
  /* TECH-7860 - TRASPASOS */

  return {
    redProperties: redProperties,
    is404: is404
  };
};

exports.checkNewConstrictionWithCommercial = checkNewConstrictionWithCommercial;